export const INTEREST_SIGNAL_EVIDENCE_OMISSIONS = [
  'plannedActivitiesTruncated',
  'otherUsersTasks',
  'timelineTruncated',
  'enrichment',
] as const;

export type InterestSignalEvidenceOmission = (typeof INTEREST_SIGNAL_EVIDENCE_OMISSIONS)[number];
